export default "__VITE_ASSET__Fi47dZeW__"